import CalendarIcon from "@assets/icons/calendar.svg";

import { MeetingType } from "@enums/meetings.enum";
import { IMeetingTagResponse } from "@interfaces/responses.interface";
import { openMeetingPage } from "@utils/navigation.util";
import { IMeetingTag } from "@interfaces/tag.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IMeetingTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IMeetingTagResponse) => void;
  onRemove?: (tag: IMeetingTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function MeetingTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  const getMeetingBackground = () => {
    switch ((data.object as IMeetingTag).type) {
      case MeetingType.INVESTMENT_COMMITTEE:
        return "#EAB308";
      case MeetingType.PIPELINE_REVIEW:
        return "#10B981";
      case MeetingType.MEETING:
        return "#EF4444";
      default:
        return "";
    }
  };

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openMeetingPage(data.object.id, (data.object as IMeetingTag).type)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <div
        className="h-5 w-[3px] flex-shrink-0 rounded-[5px]"
        style={{ background: getMeetingBackground() }}
      />

      <View.Condition if={iconOnly}>
        <CalendarIcon className="flex-shrink-0 text-[#6B7080] dark:text-invertedPrimary80" />
      </View.Condition>

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
